/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_UsersInputs */

const es_chat_tool_detail_users = /** @type {(inputs: Chat_Tool_Detail_UsersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} usuarios`)
};

const en_chat_tool_detail_users = /** @type {(inputs: Chat_Tool_Detail_UsersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} users`)
};

/**
* | output |
* | --- |
* | "{count} users" |
*
* @param {Chat_Tool_Detail_UsersInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_users = /** @type {((inputs: Chat_Tool_Detail_UsersInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_UsersInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_users(inputs)
	return en_chat_tool_detail_users(inputs)
});
export { chat_tool_detail_users as "chat.tool_detail.users" }